import type { AudioDeclarado } from '@alter/types';
import { puedeReproducirMimeType } from './audioPlayer.js';
import { puedeGrabarMimeType } from './audioRecorder.js';
import { AudioDeclaradoError } from './errors.js';

/** Qué puede hacer este cliente con audio. Inyectable para tests. */
export interface CapacidadesAudio {
  puedeReproducir(mimeType: string): boolean;
  puedeGrabar(mimeType: string): boolean;
}

/** Capacidades reales: las del `AudioPlayer` y el `AudioRecorder` de este paquete. */
export const CAPACIDADES_NAVEGADOR: CapacidadesAudio = {
  puedeReproducir: puedeReproducirMimeType,
  puedeGrabar: (mimeType) => puedeGrabarMimeType(mimeType),
};

/**
 * Valida el bloque `audio` de `GET /api/mi-simulacion` contra lo que este
 * cliente puede hacer (JC §0.2.1). Se ramifica **solo** por `mime_type`,
 * que es el campo autoritativo; `formato` y `codificacion` son
 * descriptivos.
 *
 * Va entre el Paso 2 y el Paso 3: si lanza, el caller **no** pide el
 * ticket. `POST /iniciar` marca el comienzo real de la simulación, y una
 * sesión que arranca para morir en el primer turno queda registrada como
 * intento fallido del alumno.
 *
 * @throws {AudioDeclaradoError} con `code` `downlink_no_soportado` o
 *   `uplink_no_soportado`.
 */
export function verificarAudioDeclarado(
  audio: AudioDeclarado,
  capacidades: CapacidadesAudio = CAPACIDADES_NAVEGADOR,
): void {
  if (!capacidades.puedeReproducir(audio.downlink.mime_type)) {
    throw new AudioDeclaradoError('downlink_no_soportado', audio.downlink.mime_type);
  }
  if (!capacidades.puedeGrabar(audio.uplink.mime_type)) {
    throw new AudioDeclaradoError('uplink_no_soportado', audio.uplink.mime_type);
  }
}
